var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FF0064",
    points: "0.00098 44 0.00098 0 32.00098 0 32.00098 44 16.50098 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.002,19.55967 L16.0011,3.55877 L0,19.55967 C0,21.46567 0,22.53427 0,24.44037 L16.0009,40.44127 L32.002,24.44027 C32.002,22.53427 32.002,21.46567 32.002,19.55967",
    id: "Fill-8",
    fill: "#181C4B"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    fill: "#00FFC2",
    points: "15.99267 33.08575 10.45657 27.54965 4.92047 33.08575 10.45657 38.62185"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-78",
    fill: "#00FFC2",
    points: "27.08148 33.08575 21.54538 27.54965 16.00928 33.08575 21.54538 38.62185"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-80",
    fill: "#00FFC2",
    points: "15.99267 21.99693 10.45657 16.46083 4.92047 21.99693 10.45657 27.53303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-82",
    fill: "#00FFC2",
    points: "27.08148 21.99693 21.54538 16.46083 16.00928 21.99693 21.54538 27.53303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-84",
    fill: "#00FFC2",
    points: "15.99267 10.91426 10.45657 5.37816 4.92047 10.91426 10.45657 16.45036"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-86",
    fill: "#00FFC2",
    points: "27.08148 10.91426 21.54538 5.37816 16.00928 10.91426 21.54538 16.45036"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.aae05f2c415a82c5c3d4659dcb1b7e0d.svg";
export { ForwardRef as ReactComponent };